module.exports = __webpack_public_path__ + "assets/img/staticsearchskill.322d03d5.svg";